import React, { PureComponent } from 'react';
import clsx from 'clsx';

import classes from './controls.module.scss';

interface Props {
  className?: string;
  classNameLabel?: string;
  disabled?: boolean;
  input: any; // input (compatible with redux-form: { name, value, checked, ...[onEvents] })
  label?: string;
  labelLeft?: boolean;
  meta?: any; // meta (for compatibility with redux-form: { active, dirty, ... })
}

class Switch extends PureComponent<Props> {
  render() {
    const { className, classNameLabel, disabled, input, label, labelLeft, ...otherProps } = this.props;
    const containerClasses = clsx(
      classes.container,
      classes.switch,
      label && (labelLeft ? classes.labelLeft : classes.labelRight),
      disabled && classes.disabled,
      className
    );

    return (
      <label className={containerClasses} {...otherProps}>
        <div className={classes.ctrlPad}>
          <div className={classes.ctrlFrame}>
            <input disabled={disabled} type="checkbox" {...input} />
            <span className={classes.ctrl}></span>
          </div>
        </div>
        {label && <div className={clsx(classes.label, classNameLabel)}>{label}</div>}
      </label>
    );
  }
}

export default Switch;
